module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_diamond_black.640d1392.png";